import { render, staticRenderFns } from "./CategoryFilters.vue?vue&type=template&id=037ccdab&scoped=true&"
import script from "./CategoryFilters.vue?vue&type=script&lang=js&"
export * from "./CategoryFilters.vue?vue&type=script&lang=js&"
import style0 from "./CategoryFilters.vue?vue&type=style&index=0&id=037ccdab&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037ccdab",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FilterSelect: require('/var/www/app/components/FilterSelect.vue').default})
